import React from "react";
import { Field } from "react-final-form";
import { formRow } from "../common.css.js";
import SelectInput from "./SelectInput.js";

interface Props {
    validator?: (value: string) => string | undefined;
    name: string;
    label: string;
    required?: boolean;
    options: any;
}
const SelectField: React.FC<Props> = ({ validator, name, label, options }) => {
    return (
        <div className={formRow}>
            <label>{label}</label>
            <Field
                name={name}
                component={SelectInput}
                validate={validator}
                optionsData={options}
            />
        </div>
    );
};

export default SelectField;
